
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    MultiSelectBt: () => import("../Common/MultiSelectBt.vue"),
    Slick: () => import("vue-slick")
  }
})
export default class Hero extends Vue {
  optionsBt = ["Buenos Aires, Argentina", "Buenos Aires2, Argentina2"];
  selected = this.optionsBt[0];
  cantOffer = 0;

  optSearch = [
    {
      section: "Puesto",
      info: [
        { name: "Ejecutiva de cuentas", category: "ejecutiva" },
        { name: "Ejecutiva de ventas", category: "ejecutiva" },
        { name: "Secretaria ejecutiva", category: "ejecutiva" },
        { name: "Asistente ejecutiva", category: "ejecutiva" }
      ]
    },
    {
      section: "Área",
      info: [
        { name: "Recursos Humanos", category: "rrhh" },
        { name: "Gerencia", category: "gerencia" }
      ]
    }
  ];
  options = [
    "Select option",
    "Buenos Aires, Argentina",
    "Santa Fe, Argentina",
    "Mendoza, Argentina",
    "Córdoba, Argentina"
  ];

  heroSlick = {
    slidesToShow: 4,
    dots: false,
    infinite: false,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true
        }
      }
    ]
  };

  async mounted() {
    const response = await (this as any).$root._get(
      "offer/count?is_active=1",
      {}
    );
    (this as any).cantOffer = response.totalRows;
  }

  submitSearch() {}

  beforeUpdate() {
    // if (this.$refs.slick) {
    //   (this as any).$refs.slick.destroy();
    // }
  }

  updated() {
    // this.$nextTick(function() {
    //   if (this.$refs.slick) {
    //     (this as any).$refs.slick.create();
    //   }
    // });
  }
}
